export default __webpack_public_path__ + "static/media/jcb.5d72bae0.svg";